/**
 * The name a document is shown by, wherever the client shows one.
 *
 * documents.title is nullable on a database migrated from the old schema (migrate.js adds
 * the column without NOT NULL), and a link or heading with no text has no accessible name,
 * so a missing or blank title reads as one shared phrase. The legacy document_name column
 * is gone (migrate.js drops it), so there is nothing else to fall back to.
 */
export const UNTITLED_DOCUMENT = 'Untitled document';

/**
 * @param {{ title?: string|null }|null|undefined} doc
 * @returns {string}
 */
export const documentTitle = (doc) => (typeof doc?.title === 'string' && doc.title.trim()) || UNTITLED_DOCUMENT;
